
export enum HeaderArenasStyle {
    BigTiles,
    SmallTiles,
    Menu
  }

export interface IThemeLayout {
    headerArenasStyle?: HeaderArenasStyle;
    border: {
        radius: string;
    };
}